import { useNavigate } from 'react-router-dom';
import { appManagerActions } from '../../store/appManager/actions';
import { accountTabsArray } from './../Account/AccountTabs/accountTabsArray';

import useAuth from '../../features/auth/useAuth';

import { useAppDispatch } from '../../App/redux/store';
import { modalsActions } from '../../features/modals/modalsSlice';
import './styles/UserAccountTab.scss';

function UserAccountTab() {
  const navigate = useNavigate();
  const { isManager } = useAuth({});

  const dispatch = useAppDispatch();

  const handleClick = (index) => {
    dispatch(appManagerActions.selectedAccountTab.set(index));
    dispatch(modalsActions.profileMenu(false));
    navigate('/mon-compte');
  };

  return (
    <ul className="user-account-tab">
      {accountTabsArray
        .filter((elmt) => (isManager ? true : !elmt.onlyAdmin))
        .map((elmt) => (
          <li
            key={elmt.index}
            className="user-account-tab-elt"
            onClick={() => handleClick(elmt.index)}
          >
            {elmt.name}
          </li>
        ))}
    </ul>
  );
}

export default UserAccountTab;
